<template>
    <div class="modal fade" id="change-amount-received-modal" role="dialog" @click="$emit('close')">
      <div class="modal-dialog modal-lg" @click.stop>
        <div class="modal-content">
          <div class="modal-header bg-color-info">
            <button type="button" data-dismiss="modal" class="close close-btn" @click="$emit('close')">×</button></div>
          <div class="modal-body">
            <div class="border-bottom pd-b-10">
              <p class="font-bold text-size-18">受取金額の一括変更</p>
              <p>
                <span v-if="hasSellmonScOffers || hasSellmonAcrossOffers">変更したい倉庫の受取金額をご入力ください。<br></span>
                <span>ご入力いただいた倉庫の受取金額が更新されます。</span><br>
                <span v-if="hasSellmonScOffers || hasSellmonAcrossOffers">ご入力のない倉庫の受取金額は更新されません。<br></span>
              </p>
            </div>
            <div class="border-bottom pd-f-20 pd-r-20 pd-t-20 pd-b-20">
              <div>
                <img :src="numberOfStockImage" alt="#" class="icon">
                <span class="font-bold text-size-16">Amazon倉庫</span>
              </div>
              <div class="flex flex-content-center">
                  <input-money
                    v-model="offerPrice"
                    validation="moneyMin:1|numberLength:6"
                    label="受取金額"
                    :allowNegative="false"
                    @input="handleInputofferPrice"
                    class="custom-border"
                  ></input-money>
                </div>
            </div>
            <div v-if="hasSellmonAcrossOffers" class="pd-f-20 pd-r-20 pd-t-20 pd-b-20 border-bottom">
              <div>
                <img :src="acrossTransportImage" alt="#" class="icon">
                <span class="font-bold text-size-16">ACROSS倉庫</span>
                <p>※ACROSS倉庫の表示がない商品には適用されません</p>
                <div class="flex flex-content-center">
                  <input-money
                    v-model="acrossOfferPrice"
                    validation="moneyMin:1|numberLength:6"
                    label="受取金額"
                    :allowNegative="false"
                    @input="handleInputAcrossOfferPrice"
                    class="custom-border"
                  ></input-money>
                </div>
              </div>
            </div>
            <div v-if="hasSellmonScOffers" class="pd-f-20 pd-r-20 pd-t-20 pd-b-20">
              <div>
                <img :src="scTransportImage" alt="#" class="icon">
                <span class="font-bold text-size-16">STOCKCREW倉庫</span>
                <p>※STOCKCREW倉庫の表示がない商品には適用されません</p>
                <div class="flex flex-content-center">
                  <input-money
                    v-model="scOfferPrice"
                    validation="moneyMin:1|numberLength:6"
                    label="受取金額"
                    :allowNegative="false"
                    @input="handleInputscOfferPrice"
                    class="custom-border"
                  ></input-money>
                </div>
              </div>
            </div>
            <div>
              <p>以下のASINの受取金額を一括変更します</p>
              <p style="word-wrap: break-word;">{{ checkedItems.toString() }}</p>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" data-dismiss="modal" class="btn btn-warning" @click="handleClickBulkUpdate" :disabled="disabled">
              一括更新
              <i class="fa fa-check text-size-16" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </template>

<script>
import InputMoney from '@/view/productsNew/InputMoney'

export default {
  props: {
    numberOfStockImage: {
      type: String,
      default: ''
    },
    scTransportImage: {
      type: String,
      default: ''
    },
    acrossTransportImage: {
      type: String,
      default: ''
    },
    checkedItems: {
      type: Array
    },
    hasSellmonScOffers: {
      type: Boolean
    },
    hasSellmonAcrossOffers: {
      type: Boolean
    }
  },
  data () {
    return {
      loader: null,
      disabled: true,
      scOfferPrice: null,
      acrossOfferPrice: null,
      offerPrice: null
    }
  },
  components: {
    InputMoney
  },
  mounted () {
    $('#change-amount-received-modal').modal('show')
    this.checkDisabledButton()
  },
  methods: {
    handleInputscOfferPrice (data) {
      this.scOfferPrice = data.newMoney
    },
    handleInputAcrossOfferPrice (data) {
      this.acrossOfferPrice = data.newMoney
    },
    handleInputofferPrice (data) {
      this.offerPrice = data.newMoney
    },
    checkDisabledButton () {
      this.disabled = true
      if ((this.scOfferPrice === 0) || (this.offerPrice === 0) || (this.acrossOfferPrice === 0)) {
        this.disabled = true
      } else if (this.scOfferPrice || this.offerPrice || this.acrossOfferPrice) {
        this.disabled = false
      }
      return this.disabled
    },
    handleClickBulkUpdate () {
      if (!this.checkDisabledButton()) {
        let params = {
          record: {
            asins: this.checkedItems.toString(),
            offerPrice: this.offerPrice,
            scOfferPrice: this.scOfferPrice,
            acrossOfferPrice: this.acrossOfferPrice
          }
        }
        this.$emit('handleClickBulkUpdate', params)
      }
    }
  },
  watch: {
    scOfferPrice: {
      handler () {
        this.checkDisabledButton()
      },
      deep: true
    },
    acrossOfferPrice: {
      handler () {
        this.checkDisabledButton()
      },
      deep: true
    },
    offerPrice: {
      handler () {
        this.checkDisabledButton()
      },
      deep: true
    }
  },
  beforeDestroy () {
    this.$emit('close')
  }
}
</script>
<style scoped>
  .modal-body {
    padding: 20px;
  }
  .text-size-18 {
    font-size: 18px;
  }
  .icon {
    width: 32px;
    height: auto;
  }
  @media (min-width: 992px) {
    .modal-lg {
      width: 600px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/productsNew/ChangeAmountReceivedBulkModal.vue